import {
  ApplicationConfig,
  inject,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import {
  provideRouter,
  TitleStrategy,
  withInMemoryScrolling,
  withNavigationErrorHandler,
} from '@angular/router';
import { routes } from './app.routes';
import { HttpConfigInterceptor } from './security/http-config.interceptor';
import { provideCrdApi } from './providers/crd-api.providers';
import { AppTitleStrategy } from './app-title.strategy';
import { AuthenticationService } from './security/authentication.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserAnimationsModule, MatNativeDateModule, RxReactiveFormsModule),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
      withNavigationErrorHandler(error => {
        console.error('Routing error:', error);
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideCrdApi(),
    provideAppInitializer(() => inject(AuthenticationService).initialize()),
    HttpConfigInterceptor,
    { provide: HTTP_INTERCEPTORS, useExisting: HttpConfigInterceptor, multi: true },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: MTX_DATETIME_FORMATS,
      useValue: {
        parse: {
          dateInput: 'MM/DD/YYYY',
          monthInput: 'MMMM',
          yearInput: 'yyyy',
          timeInput: 'hh:mm A',
          datetimeInput: 'MM/DD/YYYY hh:mm A',
        },
        display: {
          dateInput: 'MM/DD/YYYY',
          monthInput: 'MMMM',
          yearInput: 'yyyy',
          timeInput: 'hh:mm A',
          datetimeInput: 'MM/DD/YYYY hh:mm A',
          monthYearLabel: 'YYYY MMMM',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
          popupHeaderDateLabel: 'MMM DD, ddd',
        },
      },
    },
  ],
};
